var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSalonSocialWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Salon_Social_White",
    "data-name": "Salon Social_White",
    xmlns: "http://www.w3.org/2000/svg",
    width: 198.172,
    height: 198.18,
    viewBox: "0 0 198.172 198.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f5f5f5;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    className: "cls-1",
    d: "M198.183,37.74a8.716,8.716,0,0,0-8.706-8.712H151.345V16.918A8.712,8.712,0,0,0,148.44,0h-98.7a8.712,8.712,0,0,0-2.9,16.924V29.03H8.7A8.712,8.712,0,0,0,5.8,45.948V177.866a2.905,2.905,0,0,0,2.905,2.9H64.249L48,192.955a2.905,2.905,0,0,0,1.739,5.226h98.7a2.905,2.905,0,0,0,1.745-5.226l-16.252-12.193h55.546a2.905,2.905,0,0,0,2.9-2.9h0V45.946a8.712,8.712,0,0,0,5.811-8.206Zm-46.832,8.706h35.221v98.7H151.345ZM49.737,5.8h98.7a2.905,2.905,0,1,1,0,5.8H61.348a2.905,2.905,0,0,0,0,5.8h84.2V174.953h-5.819V113.22a2.905,2.905,0,0,0-2.905-2.915H61.348a2.905,2.905,0,0,0-2.9,2.905v61.773H52.638V14.5A2.905,2.905,0,0,0,49.733,11.6h0a2.905,2.905,0,0,1,0-5.8Zm52.257,169.178v-35.64h20.316v35.613Zm-26.128,0v-35.64H96.187v35.613Zm49.352-41.417H72.964a2.905,2.905,0,0,0-2.905,2.905h0v38.512h-5.8V116.119h69.677v58.836h-5.809V136.443a2.905,2.905,0,0,0-2.905-2.905ZM46.835,46.446v98.7H11.61v-98.7ZM8.7,34.835H46.835v5.8H8.7a2.905,2.905,0,1,1,0-5.8ZM11.61,150.954H46.835v24H11.61Zm128.117,41.419H58.447l15.484-11.612h50.319Zm11.612-17.416v-24H186.56v24ZM189.477,40.639H151.339v-5.8h38.138a2.905,2.905,0,0,1,0,5.8Z",
    transform: "translate(-0.011)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    className: "cls-1",
    d: "M35.327,137.951H53.142a2.905,2.905,0,0,0,2.905-2.905V100.2a2.905,2.905,0,0,0-2.905-2.905H35.327a2.905,2.905,0,0,0-2.9,2.905h0V135.03a2.905,2.905,0,0,0,2.9,2.921Zm2.905-34.835h12v29.028H38.237Z",
    transform: "translate(-15.022 -45.039)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    className: "cls-1",
    d: "M313.31,97.29H295.5a2.905,2.905,0,0,0-2.9,2.905h0V135.03a2.905,2.905,0,0,0,2.9,2.921h17.81a2.905,2.905,0,0,0,2.9-2.905V100.2a2.905,2.905,0,0,0-2.9-2.905Zm-2.905,34.84h-12v-29h12Z",
    transform: "translate(-135.459 -45.039)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    className: "cls-1",
    d: "M35.327,224.419H53.142a2.905,2.905,0,0,0,2.905-2.9v-34.84a2.905,2.905,0,0,0-2.905-2.9H35.327a2.9,2.9,0,0,0-2.9,2.9v34.84A2.9,2.9,0,0,0,35.327,224.419Zm2.905-34.835h12v29H38.237Z",
    transform: "translate(-15.022 -85.077)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    className: "cls-1",
    d: "M313.31,183.78H295.5a2.9,2.9,0,0,0-2.9,2.9v34.84a2.9,2.9,0,0,0,2.9,2.9h17.81a2.9,2.9,0,0,0,2.9-2.9V186.679A2.9,2.9,0,0,0,313.31,183.78ZM310.4,218.615h-12v-29h12Z",
    transform: "translate(-135.46 -85.077)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    className: "cls-1",
    d: "M141.87,74.48h-17.81a2.905,2.905,0,0,0-2.9,2.905h0V112.22a2.905,2.905,0,0,0,2.9,2.905h17.81a2.905,2.905,0,0,0,2.9-2.905V77.385A2.905,2.905,0,0,0,141.87,74.48Zm-2.9,34.841H126.984v-29h12Z",
    transform: "translate(-56.096 -34.479)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    className: "cls-1",
    d: "M226.168,75.93H208.385a2.905,2.905,0,0,0-2.905,2.9h0v34.839a2.905,2.905,0,0,0,2.905,2.905h17.783a2.905,2.905,0,0,0,2.9-2.905V78.825A2.9,2.9,0,0,0,226.168,75.93Zm-2.905,34.835H211.287v-29h12Z",
    transform: "translate(-95.13 -35.151)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalonSocialWhite);
export default __webpack_public_path__ + "static/media/Salon Social_White.60d56413c0b8f7dc65b488f17c1dd220.svg";
export { ForwardRef as ReactComponent };